import { render } from "./GameToolbar.vue?vue&type=template&id=74f9169e&scoped=true&ts=true"
import script from "./GameToolbar.vue?vue&type=script&lang=ts"
export * from "./GameToolbar.vue?vue&type=script&lang=ts"

import "./GameToolbar.vue?vue&type=style&index=0&id=74f9169e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\breno\\Documents\\Workspace\\Coll\\palavra-quadrada\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74f9169e"]])

export default __exports__